import React, { ReactElement } from "react";
import { useQuery } from "urql";
import stableStringify from "json-stable-stringify";
import { Link, useParams } from "wouter";

import { OP_CONSENTS_QUERY } from "../../../../../graphql/src/opconsent/queries";

export const OpenPaymentsConsentPage = (): ReactElement => {
    const { id } = useParams<{ id: string }>();

    const [{ fetching, error, data }] = useQuery({ query: OP_CONSENTS_QUERY, variables: { filter: { idIn: id } } });
    if (fetching) return <p>Loading</p>;
    if (error) return <p>error: {JSON.stringify(error, null, 2)}</p>;

    return (
        <>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full md:w-2/12 px-2 mb-4">
                    <Link to="/openpayments/consents">Consents page</Link>
                </div>
            </div>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full px-2 mb-4">
                    <pre>{stableStringify(data, { space: "  " })}</pre>
                </div>
            </div>
        </>
    );
};
